import { render, staticRenderFns } from "./AdmissionSummary.vue?vue&type=template&id=76f3fadf&"
import script from "./AdmissionSummary.vue?vue&type=script&lang=ts&"
export * from "./AdmissionSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f3fadf')) {
      api.createRecord('76f3fadf', component.options)
    } else {
      api.reload('76f3fadf', component.options)
    }
    module.hot.accept("./AdmissionSummary.vue?vue&type=template&id=76f3fadf&", function () {
      api.rerender('76f3fadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/AdmissionSummary.vue"
export default component.exports